/**
 * Parses the GA4 `client_id` out of a `_ga` cookie value.
 *
 * The `_ga` cookie has the shape `GA1.1.<clientId>.<timestamp>` (the two
 * leading segments are the cookie version and domain-component count). GA4's
 * Measurement Protocol expects the `client_id` as `<clientId>.<timestamp>`.
 *
 * Returns `null` when the value is missing or not in the expected format.
 *
 * Split out from `ga-client-id.ts` (which imports `next/headers`, a
 * server-only module) so it can be imported from client code too — see
 * `ga-client-id-client.ts`.
 */
export function parseGaClientId(
	gaCookieValue: string | undefined
): string | null {
	if (!gaCookieValue) {
		return null;
	}
	const parts = gaCookieValue.split(".");
	if (parts.length < 4 || parts[0] !== "GA1") {
		return null;
	}
	return parts.slice(2).join(".");
}
